/**
 * 竞价实时信息大屏显示
 */
import React from 'react';
import { Row, Col, Carousel } from 'antd';

import "./LargeScreenStyle.css";
import "./HeadBanner.css";
import logoImg from "./img/logo.png";
import completeImg from "./img/complete.png";
import waitBeginImg from "./img/waitBegin.png";

// import dealImg from "./img/deal.png";
// import failImg from "./img/fail2.png";
// import lowPriceImg from "./img/lowPrice.png";
// import auctionIngImg from "./img/auctioning.png";

import backgroundImg from "./img/background1.jpg";
import "../../../style/ui/icon.css"
import moment from 'moment';
import http from '../../../axios/http';
import { numFormat } from '../../../util/util'

const weekMap = {
    "1": "一",
    "2": "二",
    "3": "三",
    "4": "四",
    "5": "五",
    "6": "六",
    "0": "日",
}

class LotsDetail extends React.Component {

    constructor(props) {
        super(props);
        //初始化时间
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY年M月D日 ");
        let day = now.day() + "";

        this.state = {
            time: time,
            date: date + "星期" + weekMap[day],
            imageUrls: [],
            vehicleInfo: {},
            auctionLotVO: {},
            currentMoney: '',
            currentMoneyStr: '',
            status: '',
            records: [],
            currentLotsId: '',
            startTime: '',
            endTime: '',
            currentLotsIndex: 0,
            firstWxConn: true,
            countDownNum: 5,
            nextLotsData: {},
            lotsInfo: {},
            statusStyle: '',
            userMemberMap: {},
            displayCount: false,    //是否显示倒计时
            displayResult: false,   //是否显示竞价结果
            isDeal: false,          //竞价结果是否成交
            islowPrice: false,          //竞价结果是否低于保留价
            countText: "距开始",    //倒计时标签文字
            countDownTime: '',      //倒计时时间
            sessionInfo: {}
        };
    }

    componentDidMount() {
        //设置右上角的时间
        this.initTime();
        this.timerID = setInterval(() => this.initTime(), 1000);
        //设置轮播图自动切换定时任务
        this.carouselTimer = setInterval(() => this.nextCarousel(), 4000);

        let pathname = window.location.pathname;
        let params = pathname.split('/');
        this.getLotsDetail(params[3])
        this.initData();
    }

    initData = () => {
        http.get({
            url: '/auction/largescreen/findMemberAbbreviationMap',
            success: (map) => {
                this.setState({
                    userMemberMap: map,
                })
            }
        });
    }

    // 获取当前场次开始时间
    getSessionInfo = (sessionId) => {
        http.get({
            url: '/auction/largescreen/findSession',
            data: { sessionId: sessionId },
            success: (res) => {
                this.setState({
                    sessionInfo: res
                })
            }
        })
    }
    timestampToTime = (timestamp) => {
        let date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
        let D = date.getDate() + ' ';
        let h = date.getHours() + ':';
        let m = date.getMinutes() + ':';
        let s = date.getSeconds();
        return Y + M + D + h + m + s;
    }

    //获取车辆图片，包括左前脸照片
    getVehicleImagesFromVehicleInfo(vehicleInfo) {
        let vehicleImages = vehicleInfo.vehicleImages;
        if (vehicleImages !== null && vehicleImages !== undefined) {
            vehicleImages.unshift(vehicleInfo.leftFrontImage);
        }
        else {
            vehicleImages = [];
            vehicleImages.unshift(vehicleInfo.leftFrontImage);
        }
        return vehicleImages;
    }

    generateImageUrls(vehicleImages) {
        let imageUrls = [];
        if (vehicleImages !== undefined && vehicleImages !== null && vehicleImages.length > 0) {
            vehicleImages.forEach((item, index) => {
                http.post({
                    url: "/common/getOriginalImage",
                    data: { url: item },
                    success: (res) => {
                        imageUrls.push("data:image/jpeg;base64," + res);
                        if (imageUrls.length === vehicleImages.length) {
                            this.setState({
                                imageUrls: imageUrls,
                            })
                        }

                    }
                })
            });
        }
    }

    // 格式化时间
    formatTime = (timeStr) => {
        let time = new Date(timeStr);
        let yy = time.getFullYear();
        let mm = time.getMonth() + 1;
        if (mm < 10) {
            mm = "0" + mm
        }
        let dd = time.getDay();
        let hh = time.getHours();
        let mms = time.getMinutes();
        if (mms < 10) {
            mms = "0" + mms
        }
        let ss = time.getSeconds();
        if (ss < 10) {
            ss = "0" + ss
        }
        let str = yy + "年" + mm + "月" + dd + "日 " + hh + ":" + mms + ":" + ss;
        return str
    }

    // 获取竞品详情 
    getLotsDetail = (id) => {
        http.get({
            url: '/auction/largescreen/lotsInfo',
            data: {
                lotsId: id
            },
            success: (res) => {
                this.getSessionInfo(res.auctionLotVO.sessionId)
                let vehicleImages = this.getVehicleImagesFromVehicleInfo(res.vehicleInfo);
                this.generateImageUrls(vehicleImages);
                let records = res.auctionLotVO.bidRecords;
                let currentMoney = res.auctionLotVO.startPrice;
                let currentMoneyStr = numFormat(currentMoney);
                let statusStyle = ''
                res.auctionLotVO.startPriceStr = numFormat(res.auctionLotVO.startPrice)
                res.auctionLotVO.startTimeStr = this.formatTime(res.auctionLotVO.startTime)
                res.auctionLotVO.endTimeStr = this.formatTime(res.auctionLotVO.endTime)

                if (records !== undefined && records !== null && records.length > 0) {
                    currentMoney = records[0].offer;
                    currentMoneyStr = numFormat(records[0].offer)
                }
                if (res.auctionLotVO.status === 0) {
                    res.auctionLotVO.statusStr = '无人出价'
                    statusStyle = "auction-right-infoTip";
                } else if (res.auctionLotVO.status === 1 || res.auctionLotVO.status === 3) {
                    res.auctionLotVO.statusStr = '已成交'
                    statusStyle = "auction-right-infoTip auction-right-success";
                } else if (res.auctionLotVO.status === 2) {
                    res.auctionLotVO.statusStr = '低于保留价'
                    statusStyle = "auction-right-infoTip ";
                }
                this.setState({
                    lotsInfo: res,
                    auctionLotVO: res.auctionLotVO,
                    vehicleInfo: res.vehicleInfo,
                    currentMoneyStr: currentMoneyStr,
                    records: records,
                    statusStyle: statusStyle
                })
            }
        })
    }

    initTime = () => {
        let now = new moment();
        let time = now.format("H:mm:ss");
        let date = now.format("YYYY年M月D日 ");
        let day = now.day() + "";
        this.setState({
            time: time,
            date: date + "星期" + weekMap[day]
        });
    }

    componentWillUnmount() {
        clearInterval(this.timerID);
        clearInterval(this.carouselTimer);
    }

    //生成轮播图车辆图片
    createVehicleImagesDoms = () => {
        const { imageUrls } = this.state;
        let doms = [];
        if (imageUrls !== undefined && imageUrls !== null && imageUrls.length > 0) {
            imageUrls.forEach((item, index) => {
                doms.push((<div key={index}>
                    <div className="slider-item" style={{ width: '100%', height: '44.4vh', minHeight: '400px', background: "url(" + item + ") no-repeat center center", backgroundSize: "cover" }}>
                    </div>
                </div>));
            });
        }
        return doms;
    }

    //出价记录
    createBidTable() {
        const { records, auctionLotVO } = this.state;
        const userMemberMap = this.props.userMemberMap;
        let doms = [];
        let showBidder = auctionLotVO.showBidder === 1;
        if (records !== undefined && records !== null && records.length > 0) {
            let length = records.length;
            for (let i = 0; i < records.length && i < 30; i++) {
                //第0个出价为成功
                let status = i === 0 ? "最高价" : "已出局";
                let className = "table-bid-record";
                if (i === 0) {
                    className = "table-bid-record highest-price";
                }
                let item = records[i];
                let username = item.username;
                let memberCode = item.memberCode;
                if (!showBidder) {
                    username = "*****";
                }
                else {
                    username = userMemberMap[memberCode];
                    // if (username === null || username === undefined) {
                    //     username = item.username;
                    // } 
                }
                let dom = (
                    <Row className='bid-row' key={i}>
                        <Col className={className} span={5}>{length - i}</Col>
                        <Col className={className} span={5}>{status}</Col>
                        <Col className={className} span={8}>{username}</Col>
                        <Col className={className} span={6}>{numFormat(item.offer)}</Col>
                    </Row>
                );
                doms.push(dom);
            }
        }
        else {
            doms.push((
                <div key="record-empty" className="empty-data">暂无数据</div>
            ));
        }
        return doms;
    }

    nextCarousel = () => {
        if (this.refs.carousel) {
            this.refs.carousel.next();
        }
    }

    render() {
        const { auctionLotVO, vehicleInfo } = this.state;
        let status = auctionLotVO.status;
        return (
            <div className="root" style={{ background: 'url(' + backgroundImg + ') no-repeat', backgroundSize: 'cover' }}>
                <div className="head" style={{ textAlign: 'center' }}>
                    <div className="head-container">
                        <div className='head-left head-div'>
                            <img className="head-logo-img" src={logoImg} alt="logo" />
                            <div className="head-logo-text">厦门二手车交易市场网上竞价大厅</div>
                        </div>
                        <div className='head-center head-div'>
                            <img className="head-status-img" src={status === null ? waitBeginImg : completeImg} alt="status" />
                        </div>
                        <div className='head-right head-div'>
                            <span className="head-right-time">{this.state.time}</span><br />
                            <span className="head-right-date">{this.state.date}</span>
                        </div>
                    </div>
                </div>
                <div className='main-container'>
                    <div className="main">
                        <div className="main-left main-background">
                            <div className="left-top car-detail">
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.brandModel}</span><br />
                                <span className="left-item-field">品牌型号</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.plateNo}</span><br />
                                <span className="left-item-field">车牌号</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.registerDate}</span><br />
                                <span className="left-item-field">初登日期</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.registerLocation}</span><br />
                                <span className="left-item-field">初次登记地</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.vin}</span><br />
                                <span className="left-item-field">VIN码</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.useProperty}</span><br />
                                <span className="left-item-field">使用性质</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.seatNum ? vehicleInfo.seatNum : "未知"}</span><br />
                                <span className="left-item-field">座位数</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.transferTimes}</span><br />
                                <span className="left-item-field">过户次数</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.mileage}公里</span><br />
                                <span className="left-item-field">表显里程</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.displacement}</span><br />
                                <span className="left-item-field">发动机排量</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.gearBox}</span><br />
                                <span className="left-item-field">变速箱类型</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.driveMode}</span><br />
                                <span className="left-item-field">驱动方式</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.commerciaInsuranceDate ? vehicleInfo.commerciaInsuranceDate : "未录入"}</span><br />
                                <span className="left-item-field">商业险到期</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.mandatoryInsuranceDate ? vehicleInfo.mandatoryInsuranceDate : "未录入"}</span><br />
                                <span className="left-item-field">交强险到期</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.examinationDate ? vehicleInfo.examinationDate : "未录入"}</span><br />
                                <span className="left-item-field">车检到期</span>
                            </div>
                            <div className="left-item">
                                <span className="left-item-data">{vehicleInfo.fueltype}</span><br />
                                <span className="left-item-field">能源类型</span>
                            </div>
                        </div>
                        <div className="main-center main-background">
                            <div className="main-slider">
                                <Carousel ref="carousel">
                                    {this.createVehicleImagesDoms()}
                                </Carousel>
                                <div className='countdown-bar'>
                                    <i className='countdown-icon iconfont icon-clock'>
                                    </i>
                                    {this.state.sessionInfo.status === 2 ? <span className='countdown-time countdown-startTime'><span className='countdown-text'>&nbsp;&nbsp; 结束时间：</span>{auctionLotVO.endTime}</span> :
                                        <span className='countdown-time countdown-startTime'><span className='countdown-text'>&nbsp;&nbsp; 开始时间：</span>{this.state.sessionInfo.startTime}</span>}

                                    <div className="gradient-div1">
                                        <img id="waiteBegin-img" src={auctionLotVO.status === null ? waitBeginImg : completeImg} alt="waiteBegin-img" />
                                    </div>
                                </div>
                            </div>
                            <div className="center-name-box">
                                <span className="car-name1">{auctionLotVO.name}</span>
                                <span className="car-number">车辆编号:  {auctionLotVO.code}</span>
                            </div>
                            <div className='center-detail'>
                                <div className="center-detail-item">
                                    <div className='detail-icon iconfont icon-clock'>
                                    </div>
                                    <div className='detail-info'>
                                        <span className="left-item-data">{vehicleInfo.registerDate}</span><br />
                                        <span className="left-item-field">初登日期</span>
                                    </div>
                                </div>

                                <div className="center-detail-item">
                                    <div className='detail-icon iconfont icon-mileage'>
                                    </div>
                                    <div className='detail-info'>
                                        <span className="left-item-data">{vehicleInfo.mileage}公里</span><br />
                                        <span className="left-item-field">表显里程</span>
                                    </div>
                                </div>

                                <div className="center-detail-item">
                                    <div className='detail-icon iconfont icon-gear'>
                                    </div>
                                    <div className='detail-info'>
                                        <span className="left-item-data">{vehicleInfo.gearBox}</span><br />
                                        <span className="left-item-field">变速箱类型</span>
                                    </div>
                                </div>

                                <div className="center-detail-item">
                                    <div className='detail-icon iconfont icon-displacement'>
                                    </div>
                                    <div className='detail-info'>
                                        <span className="left-item-data">{vehicleInfo.displacement}</span><br />
                                        <span className="left-item-field">发动机排量</span>
                                    </div>
                                </div>
                            </div>
                            <div className='main-center-bottom-box padding-left'>
                                <span className='price-label'>起始价</span>
                                <span className='price-tag'>￥{auctionLotVO.startPriceStr}</span>
                            </div>
                            <div className='main-center-bottom-box'>
                                <span className='price-label'>最高价</span>
                                <span className='price-tag red-color'>￥{this.state.currentMoneyStr}</span>
                            </div>
                            <div className='main-center-follow'>
                                <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{this.state.records ? this.state.records.length : '0'}</span> &nbsp;&nbsp;人出价</span><br />
                                <span className='follow-label'><span className='follow-label red-color font-Gilroy'>{auctionLotVO.followNum ? auctionLotVO.followNum : '0'}</span> &nbsp;&nbsp;人关注</span><br />
                            </div>
                        </div>
                        <div className="main-right main-background">
                            <div className="right-top">
                            </div>
                            <Row className='bid-table-head'>
                                <Col span={5}>
                                    <div className="table-head-text">
                                        序号
                                    </div>
                                </Col>
                                <Col span={5}>
                                    <div className="table-head-text">
                                        状态
                                    </div>
                                </Col>
                                <Col span={8}>
                                    <div className="table-head-text">
                                        竞价用户
                                    </div>
                                </Col>
                                <Col span={6}>
                                    <div className="table-head-text">
                                        出价
                                    </div>
                                </Col>
                            </Row>
                            {this.createBidTable()}
                        </div>
                    </div>
                </div>
                {auctionLotVO.sessionName ? <div className='show-count'>{auctionLotVO.sessionName}&nbsp;{auctionLotVO.currentLotsIndex + 1} / {auctionLotVO.lotsNum}</div> : ""}
            </div>);
    }
}

export default LotsDetail;